module.exports = __webpack_public_path__ + "img/derkoportallogo.950bc74d.png";